import httpClient from '@/http-client'

export const getData = (Options = {}) => {
  return httpClient
    .get('/api/student-top-fives', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  getData
}
